import React, { useContext, useEffect, useState } from "react";
import { useLanguage } from "../../LanguageProvider";
import ModuleSidebar from "../../components/ModuleSidebar/ModuleSidebar";
import "./Notebook.css";
import { TbBell, TbBulb, TbHeart, TbTrash } from "react-icons/tb";
import { LuNewspaper } from "react-icons/lu";
import AllNotes from "./Views/AllNotes";
import Ideas from "./Views/Ideas";
import AddNoteFolder from "./components/AddNoteFolder/AddNoteFolder";
import { GeneralContext } from "../../GeneralProvider";
import FavouriteNotes from "./Views/FavouriteNotes";

export default function Notebook() {
  const { handleCreateNoteFolder, getMyNotes, myNotes, handleUpdateNoteFolderTitle, handleDeleteNoteFolder, selectedNote, setSelectedNote } = useContext(GeneralContext);
  const { getTranslation } = useLanguage();
  const [selectedSubmenuId, setSelectedSubmenuId] = useState(1);
  const [isAddFolderModalOpen, setIsAddFolderModalOpen] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState(null); // Selected Folder State

  const generateDynamicFolderMenu = () => {
    const folderItems = myNotes?.folders?.map(folder => {
      const nestedSubmenu = folder.notes.map(note => ({
        title: note.title ? note.title : getTranslation("untitled"),
        id: note.noteId,
        noteId: note.noteId,
      }));

      return {
        title: folder.title,
        id: folder.folderId,
        nestedSubmenu,
      };
    }) || [];

    const ungroupedNotes = myNotes?.notes?.filter(note => note.folderId === null) || [];
    const ungroupedItems = ungroupedNotes.map(note => ({
      title: note.title ? note.title : getTranslation("untitled"),
      id: note.noteId,
      noteId: note.noteId,
    }));

    return {
      title: getTranslation("folders"),
      icon: "",
      disableContextMenu: true,
      submenu: [
        ...ungroupedItems,
        ...folderItems
      ]
    };
  };

  const handleFolderClick = (folderId) => {
    setSelectedFolderId(folderId);
  };

  const menus = [
    {
      sections: [
        {
          title: getTranslation('quickLinks'),
          icon: "",
          showEntityButton: false,
          submenu: [
            { title: getTranslation('allNotes'), id: 1, icon: <LuNewspaper size={18} /> },
            { title: getTranslation('favourites'), id: 4, icon: <TbHeart size={18} /> },
            // { title: getTranslation('trash'), id: 5, icon: <TbTrash size={18} /> }
          ],
        },
        generateDynamicFolderMenu()
      ],
    }
  ];

  const handleSubmenuClick = (submenu) => {
    setSelectedSubmenuId(submenu.id);
    if (submenu.noteId) {
      const folderNote = myNotes.folders?.flatMap(folder =>
        folder.notes?.map(note => ({ ...note, folderTitle: folder.title })) || []
      ).find(note => note.noteId === submenu.noteId);

      const ungroupedNote = myNotes.notes?.find(note => note.noteId === submenu.noteId);

      const foundNote = folderNote || ungroupedNote;

      setSelectedFolderId(foundNote.folderId);

      if (foundNote) {
        setSelectedNote(foundNote);
      }
    }
    else {
      setSelectedNote(null)
      setSelectedFolderId("");
    }
  };

  const handleAddFolder = () => {
    setIsAddFolderModalOpen(true);
  };

  useEffect(() => {
    getMyNotes();
    setSelectedNote(null)
  }, []);

  return (
    <div className="notebook-container">
      <ModuleSidebar
        title={getTranslation('myNotes')}
        menus={menus}
        selectedSubmenu={selectedSubmenuId}
        onSubmenuClick={handleSubmenuClick}
        addEntitiy={handleAddFolder}
        deleteMessage={getTranslation("areYouSureDeleteNote")}
        groupContextMenuRenameOnClick={(id, newTitle) => { handleUpdateNoteFolderTitle(id, newTitle) }}
        groupContextMenuDeleteOnClick={(id) => handleDeleteNoteFolder(id)}
        groupDeleteMessage={getTranslation("folderDeleteConfirmation")}
        hideBranch
        onFolderClick={handleFolderClick} // Pass the folder click handler
        selectedFolderId={selectedFolderId} // Pass the selected folder id
      />
      <div className="notebook-content">
        <div className="notebook-inner-content">
          {((selectedSubmenuId === 1 || selectedNote) && selectedSubmenuId !== 4) &&
            <AllNotes
              initialSelectedNote={selectedNote}
              setSelectedSubmenuId={setSelectedSubmenuId}
              setSelectedNote={setSelectedNote}
              selectedFolderId={selectedFolderId}
            />
          }
          {(selectedSubmenuId === 4) &&
            <FavouriteNotes
              initialSelectedNote={selectedNote}
              setSelectedSubmenuId={setSelectedSubmenuId}
              setSelectedNote={setSelectedNote}
              selectedFolderId={selectedFolderId}
            />
          }
          {selectedSubmenuId === 3 && <Ideas />}
        </div>
      </div>

      <AddNoteFolder
        isOpen={isAddFolderModalOpen}
        onClose={() => setIsAddFolderModalOpen(false)}
        onCreate={handleCreateNoteFolder}
      />
    </div>
  );
}
